import { updateObject, } from './../../utils/utility';

const initialState = {
    quoteSummary: null,
    quoteSaved: false
}


const setQuoteSaved = (state = initialState, action) => {
    return updateObject(state, {
        quoteSaved: true
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_QUOTE_SAVED") {
        return setQuoteSaved(state, action)
    }

    return state;
}

export default reducer;